import { render, staticRenderFns } from "./TextAndImage.vue?vue&type=template&id=39b77315&"
import script from "./TextAndImage.vue?vue&type=script&lang=js&"
export * from "./TextAndImage.vue?vue&type=script&lang=js&"
import style0 from "./TextAndImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextAndImage.vue"
export default component.exports